/**
 * @author Ivan Toth.
 */
var treeBind = { item: '=', caller: '=', level: '=', parent: '=' };
var DetailTreeController = (function () {
    function DetailTreeController(topic, settings) {
        this.topic = topic;
        this.settings = settings;
        this.visible = true;
        this.defaultState = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.excludeCountries = ['JP', 'CN', 'TW', 'HK', 'BR', 'AF', 'AU', 'BN', 'KH', 'FJ', 'PH', 'BT', 'SG', 'SB', 'LA',
            'TL', 'IN', 'ID', 'PG', 'LK', 'AS', 'KR', 'KP', 'VN', 'BD', 'MY', 'MV', 'NZ', 'TH', 'WS'];
        return;
    }
    ;
    DetailTreeController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTreeController.prototype.rbr = function (v) {
        if (angular.isDefined(v)) {
            return v.replace(/<br>/g, '\n');
        }
    };
    DetailTreeController.prototype.parseSAPAmount = function (amount) {
        try {
            amount = String(amount).trim();
            if (amount.includes('.') && amount.includes(',')) {
                return amount.lastIndexOf('.') > amount.lastIndexOf(',')
                    ? Number(amount.split(',').join(''))
                    : Number(amount.split('.').join('').replace(',', '.'));
            }
            if (amount.includes('.')) {
                var parts = amount.split('.');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount);
            }
            if (amount.includes(',')) {
                var parts = amount.split(',');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount.replace(',', '.'));
            }
            return Number(amount);
        }
        catch (e) {
            return NaN;
        }
    };
    DetailTreeController.$inject = ['topic', 'settings'];
    return DetailTreeController;
}());
var DetailTreeComponent = (function () {
    function DetailTreeComponent() {
        this.bindings = treeBind;
        this.templateUrl = 'detail-tree.html';
        this.controller = DetailTreeController;
    }
    return DetailTreeComponent;
}());
angular
    .module('application')
    .component('detailTreeSection', new DetailTreeComponent());

//# sourceMappingURL=detail.tree.component.js.map
